import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.boundUpdateStatus = this.updateStatus.bind(this)
    window.addEventListener('online', this.boundUpdateStatus)
    window.addEventListener('offline', this.boundUpdateStatus)
    this.updateStatus()
  }

  disconnect() {
    window.removeEventListener('online', this.boundUpdateStatus)
    window.removeEventListener('offline', this.boundUpdateStatus)
  }

  updateStatus() {
    this.element.classList.toggle('hidden', navigator.onLine)
    this.element.setAttribute('aria-hidden', navigator.onLine ? 'true' : 'false')
  }
}

